import React from "react";
import {Aggregation, AggregationGroup} from "../../SearchResult";
import FacetGroup from "./FacetGroup";
import Facet from "./Facet";

interface PresentersFacetProps {
    aggs: AggregationGroup<"presenters">;
    activeAggregations: Set<string>;
}

export default function PresentersFacet({aggs, activeAggregations}: PresentersFacetProps) {
    return (
        <FacetGroup title="Presenter">         
            {aggs.aggregations.map(({facet, count}: Aggregation) => (
                <Facet
                    key={facet}
                    type="presenters"
                    facet={facet}
                    count={count}
                    isActive={activeAggregations.has(facet)}
                />
            ))}
        </FacetGroup>
    );
}
